import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { mockPosts } from '../data/blogData';

const BlogOverview = () => {
  const [activeCategory, setActiveCategory] = useState('All');

  const categories = ['All', 'Reviews', 'Deals'];

  const filteredPosts = activeCategory === 'All' 
    ? mockPosts 
    : mockPosts.filter(post => post.category === activeCategory);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div className="blog-overview">
      <div className="blog-header">
        <h1 style={{
          fontSize: '3rem',
          fontWeight: '800',
          background: 'linear-gradient(135deg, #64ffda 0%, #00ff88 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          marginBottom: '1rem'
        }}>Latest Articles</h1>
        <p className="blog-subtitle">Insights, reviews, and guides not only for Extraterrestrials </p>
      </div>

      <div className="blog-category-filter">
        {categories.map((category) => (
          <button
            key={category}
            className={`blog-filter-btn ${activeCategory === category ? 'active' : ''}`}
            onClick={() => setActiveCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>
      
      <div className="blog-grid">
        {filteredPosts.map((post) => (
          <article key={post.slug} className="blog-card">
            <div className="blog-card-header">
              <span className="blog-category">{post.category}</span>
              <time className="blog-date">{formatDate(post.date)}</time>
            </div>
            
            <h2 className="blog-title">{post.title}</h2>
            <p className="blog-description">{post.description}</p>
            
            <div className="blog-card-footer">
              <Link to={`/blog/${post.slug}`} className="blog-read-more">
                Read More
                <span className="blog-arrow">→</span>
              </Link>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default BlogOverview;